'use client'

import cn from 'clsx'
import { useEffect, useState } from 'react'
import { AddToCart } from '~/integrations/shopify/cart/add-to-cart'
import s from './size-and-buy.module.css'
export function SizeAndBuy({ product, className }) {
  const [selectedSize, setSelectedSize] = useState(null)
  const [selectedColor, setSelectedColor] = useState(null)
  const [selectedVariant, setSelectedVariant] = useState(null)

  const sizes = product?.options?.find(
    (option) => option.name === 'Size'
  )?.values
  const colors = product?.options?.find(
    (option) => option.name === 'Color'
  )?.values

  const findVariant = (size, color) => {
    return product?.variants.find((variant) =>
      variant.selectedOptions.every(
        (option) =>
          (option.name === 'Size' ? option.value === size : true) &&
          (option.name === 'Color' ? option.value === color : true)
      )
    )
  }

  useEffect(() => {
    if (!product || !product.variants) return // Wait until product data is loaded

    const defaultSize = sizes?.length === 1 ? sizes[0] : null
    const defaultColor = colors?.length === 1 ? colors[0] : null

    setSelectedSize(defaultSize)
    setSelectedColor(defaultColor)
    setSelectedVariant(findVariant(defaultSize, defaultColor))
  }, [product, sizes, colors])

  const handleSizeClick = (value) => {
    setSelectedSize(value)
    const variant = findVariant(value, selectedColor)
    setSelectedVariant(variant)
  }

  const handleColorClick = (value) => {
    setSelectedColor(value)
    const variant = findVariant(selectedSize, value)
    setSelectedVariant(variant)
  }

  return (
    <div className={cn(className, 'grid sgap-y-4')}>
      {/* Size Picker */}
      {sizes?.length > 1 && (
        <ul className="w-full flex dt:sgap-x-8 sgap-x-4">
          {sizes?.map((value) => (
            <li
              key={value}
              className="grow"
            >
              <button
                type="button"
                onClick={() => handleSizeClick(value)}
                data-active={value === selectedSize}
                className={cn(
                  s.hover,

                  'w-full cta border border-contrast text-center spy-16 dt:spy-4 spx-8 opacity-50',
                  'data-[active=true]:bg-contrast data-[active=true]:text-secondary data-[active=true]:opacity-100'
                )}
              >
                {value}
              </button>
            </li>
          ))}
        </ul>
      )}

      {/* Color Picker */}
      {colors?.length > 1 && (
        <ul className="w-full flex sgap-4">
          {colors?.map((value) => (
            <li
              key={value}
              className="grow"
            >
              <button
                type="button"
                onClick={() => handleColorClick(value)}
                data-active={value === selectedColor}
                className={cn(
                  s.hover,
                  'w-full border border-contrast text-center spy-15 dt:spy-4 spx-8 opacity-50',
                  'data-[active=true]:bg-contrast data-[active=true]:text-secondary data-[active=true]:opacity-100'
                )}
              >
                {value}
              </button>
            </li>
          ))}
        </ul>
      )}

      <div
        className={cn(
          'relative flex items-center',
          !selectedVariant && 'bg-contrast text-secondary/25'
        )}
      >
        <AddToCart
          product={product}
          variant={selectedVariant}
          className="w-full spx-8 spy-17 dt:spy-4"
          icon={
            <span className="absolute sright-8">
              ${Number(product?.priceRange.maxVariantPrice.amount).toFixed(2)}
            </span>
          }
        />
      </div>
    </div>
  )
}
